import React, { useEffect, useState } from 'react';
import Button from '../Button';
import styles from './styles.scoped.css';
import IconArrowDown from '../../icons/IconArrowDown';

export default function ScrollToTop() {
  const [showScroll, setShowScroll] = useState(false);

  const container = document.getElementById('children-container');

  const handleScroll = () => {
    setShowScroll(container.scrollTop > container.clientHeight - 200);
  };

  const scrollToTop = () => {
    container.scroll({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    container?.addEventListener('scroll', handleScroll);
    return () => container?.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={[
        styles.root,
        showScroll ? styles.visible : styles.hidden,
      ].join(' ')}
    >
      <Button onClick={scrollToTop}>
        <IconArrowDown className={styles.iconUp}/>
      </Button>
    </div>
  );
}
